import { CheckStatus, Parse, ParseText } from '../utils/ajax';

export default {

    /**
     * @param {string} name The name of the player.
     * @param {string} tenantId The tenant ID of where the player is hosted.
     * @description Fetching a single player hosted within a specific tenant.
     * Returns text/html of the specified player. This endpoint requires no authentication
     */
    get: (name, tenantId) => (fetch(`/${tenantId}/play/${name}`)
        .then(CheckStatus)
        .then(ParseText)
    ),

    getAll: (tenantId, authenticationToken) => (fetch(`/${tenantId}/play`, {
        headers: {
            Authorization: authenticationToken,
            ManyWhoTenant: tenantId,
        },
    })
        .then(CheckStatus)
        .then(Parse)
    ),

    save: (name, html, tenantId, authenticationToken) => (fetch(`/${tenantId}/play/${name}`, {
        method: 'POST',
        headers: {
            ManyWhoTenant: tenantId,
            Authorization: authenticationToken,
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        },
        body: `=${html}`,
    })
        .then(CheckStatus)
        .then(ParseText)
    ),

    delete: (name, tenantId, authenticationToken) => (fetch(`/${tenantId}/play/${name}`, {
        method: 'DELETE',
        headers: {
            ManyWhoTenant: tenantId,
            Authorization: authenticationToken,
        },
    })
        .then(CheckStatus)
    ),
};
